var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
import { fetchConsultar, fetchConsultarPaginada, fetchCadastrar, fetchArquivos, URL_API } from '../../../api';
import { getTokenFromCookie } from '../../../services/mt_login';
export { STATUS_API } from '../../../api';
var ROTA_VAGAS_TRABALHO = 'atendimentos';
export var getOfertasVagasTrabalhos = function (TextoBusca, StatusOferta, Instituicao, PerfilLaboral, DataInicio, DataFim, Regime, PaginationModel) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (StatusOferta)
                    Query += "status_ofertas=".concat(encodeURIComponent(StatusOferta), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (PerfilLaboral)
                    Query += "perfil_laboral=".concat(PerfilLaboral, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                if (Regime)
                    Query += "tipo_regime=".concat(Regime, "&");
                URL = "".concat(ROTA_VAGAS_TRABALHO, "/?").concat(Query);
                return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getVagas = function (TextoBusca, StatusVagas, Instituicao, PerfilLaboral, DataInicio, DataFim, PaginationModel) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (StatusVagas)
                    Query += "status_vagas=".concat(encodeURIComponent(StatusVagas), "&");
                if (Instituicao)
                    Query += "instituicao=".concat(Instituicao, "&");
                if (PerfilLaboral)
                    Query += "perfil_laboral=".concat(PerfilLaboral, "&");
                if (DataInicio)
                    Query += "data_inicio=".concat(encodeURIComponent(DataInicio), "&");
                if (DataFim)
                    Query += "data_fim=".concat(encodeURIComponent(DataFim), "&");
                URL = "".concat(ROTA_VAGAS_TRABALHO, "/vagas/?").concat(Query);
                return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getCombosListarVagas = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_VAGAS_TRABALHO, "/combos-listar-vagas"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//vagas
export var getVagasOferta = function (OfertaID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_VAGAS_TRABALHO, "/").concat(OfertaID, "/vagas"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//Reeducandos
var ROTA_ATENDIMENTOS = 'atendimentos';
export var getReeducandosOferta = function (OfertaID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_ATENDIMENTOS, "/ofertas/").concat(OfertaID, "/reeducandos");
                return [4 /*yield*/, fetchConsultar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getOferta = function (OfertaID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_ATENDIMENTOS, "/ofertas/").concat(OfertaID);
                return [4 /*yield*/, fetchConsultar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getVagaTrabalho = function (VagaID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_ATENDIMENTOS, "/vagas/").concat(VagaID);
                return [4 /*yield*/, fetchConsultar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarAgendamento = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/agendamento");
                return [4 /*yield*/, fetchArquivos(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarEncaminhamento = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCadastrar("".concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/encaminhamento"), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarDesistencia = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCadastrar("".concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/desistencia"), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var finalizarAtendimento = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCadastrar("".concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/finalizar"), Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var reiniciarAtendimento = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/reiniciar"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var gerarTermoCompromisso = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var TOKEN, response, error, pdfBlob;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                TOKEN = getTokenFromCookie();
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/termo-compromisso"), {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer ".concat(TOKEN),
                            'Content-Type': 'application/pdf',
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    error = new Error('Não foi possível emitir o termo');
                    error.httpStatus = response.status;
                    throw error;
                }
                return [4 /*yield*/, response.blob()];
            case 2:
                pdfBlob = _a.sent();
                return [2 /*return*/, window.URL.createObjectURL(pdfBlob)];
        }
    });
}); };
export var gerarTermoEncaminhamento = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var TOKEN, response, pdfBlob, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                TOKEN = getTokenFromCookie();
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(ROTA_ATENDIMENTOS, "/").concat(ID, "/termo-encaminhamento"), {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer ".concat(TOKEN),
                            'Content-Type': 'application/pdf',
                        },
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('Failed to fetch PDF');
                }
                return [4 /*yield*/, response.blob()];
            case 2:
                pdfBlob = _a.sent();
                // Cria uma URL temporária para o Blob
                return [2 /*return*/, window.URL.createObjectURL(pdfBlob)];
            case 3:
                error_1 = _a.sent();
                console.error('Erro ao gerar o PDF:', error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
